import { usePathname } from 'next/navigation';

import { isEmpty } from 'lodash';

import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';

import pageRights from '@/lib/acl/pageRights';
import { HOME } from '@/lib/routes/privateRoutes';

export const useRequiresSpecificPlan = () => {
    const pathname = usePathname();

    const { subscription } = useSubscription();

    if (subscription?.product_key && !isEmpty(pageRights[pathname]?.plans)) {
        const validPlans = pageRights[pathname]?.plans;

        if (!validPlans?.includes(subscription.product_key as (typeof validPlans)[0])) {
            return { hasAccess: false, redirect_url: HOME };
        }
    }

    return { hasAccess: true, redirect_url: null };
};
